'use client';

import { Suspense } from 'react';

import dynamic from 'next/dynamic';

import { useGlobalData } from '@/providers/GlobalDataProvider';

// Dynamic imports for modal components
const WalletConnectDialog = dynamic(
  () => import('@/components/global/WalletConnect/WalletConnectDialog'),
  { ssr: false }
);

const WelcomeDialog = dynamic(
  () => import('@/components/global/WalletConnect/WelcomeDialog'),
  {
    ssr: false
  }
);

const AccountSheet = dynamic(() => import('@/components/shared/AccountSheet'), {
  ssr: false
});

interface I_HeaderModalsProps {
  closeWalletConnect: () => void;
  closeWelcome: () => void;
  closeAccount: () => void;
  handleWalletPick: (walletId: string) => void;
  setPendingWallet: (walletId: string) => void;
  handleEditProfile: () => void;
  handleSignOut: () => void;
}

export function HeaderModals({
  closeWalletConnect,
  closeWelcome,
  closeAccount,
  handleWalletPick,
  setPendingWallet,
  handleEditProfile,
  handleSignOut
}: I_HeaderModalsProps) {
  const isWalletConnectOpen = useGlobalData('isWalletConnectOpen') || false;
  const isWelcomeOpen = useGlobalData('isWelcomeOpen') || false;
  const isAccountOpen = useGlobalData('isAccountOpen') || false;

  return (
    <>
      <Suspense>
        <WalletConnectDialog
          open={isWalletConnectOpen}
          onOpenChange={v => (v ? null : closeWalletConnect())}
          onPick={handleWalletPick}
          setPendingWallet={setPendingWallet}
        />
      </Suspense>

      <Suspense>
        <WelcomeDialog
          open={isWelcomeOpen}
          onOpenChange={v => (v ? null : closeWelcome())}
          onEditProfile={handleEditProfile}
        />
      </Suspense>

      <Suspense>
        <AccountSheet
          open={isAccountOpen}
          onOpenChange={v => (v ? null : closeAccount())}
          onSignOut={handleSignOut}
        />
      </Suspense>
    </>
  );
}
